import React from 'react';
import { ChevronLeft, ChevronRight, Settings } from 'lucide-react';

const Header = ({ canGoBack, canGoForward, onGoBack, onGoForward, onNavigateToSettings }) => {
  return (
    <header className="h-16 bg-dark-50 border-b border-dark-200 flex items-center justify-between px-6">
      {/* 导航按钮 */}
      <div className="flex items-center gap-2">
        <button 
          onClick={onGoBack}
          disabled={!canGoBack}
          className={`p-2 rounded-full transition-colors duration-200 ${
            canGoBack 
              ? 'hover:bg-dark-100 text-dark-600' 
              : 'text-dark-300 cursor-not-allowed'
          }`}
          title="上一页"
        >
          <ChevronLeft size={20} />
        </button>
        <button 
          onClick={onGoForward}
          disabled={!canGoForward}
          className={`p-2 rounded-full transition-colors duration-200 ${
            canGoForward 
              ? 'hover:bg-dark-100 text-dark-600' 
              : 'text-dark-300 cursor-not-allowed'
          }`}
          title="下一页"
        >
          <ChevronRight size={20} />
        </button>
      </div>

      {/* 空白区域 */}
      <div className="flex-1"></div>

      {/* 用户操作 */}
      <div className="flex items-center gap-2">
        <button 
          onClick={onNavigateToSettings}
          className="p-2 hover:bg-dark-100 rounded-full transition-colors duration-200"
          title="设置"
        >
          <Settings size={20} className="text-dark-400" />
        </button>
      </div>
    </header>
  );
};

export default Header;
